const PLATFORMS_LIST = ['Marina', 'Cloud'];
const DEFAULT_PLATFORM = PLATFORMS_LIST[0];

export { PLATFORMS_LIST, DEFAULT_PLATFORM };
